import { PosIconProps } from './SvgWrapper';

export function ErrorIcon(props: Omit<PosIconProps, 'viewBox'>) {
  return (
    <svg
      width={props.width ?? '30'}
      height={props.width ?? '30'}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 2.5C21.8878 2.5 27.5 8.11224 27.5 15C27.5 21.8878 21.8878 27.5 15 27.5C8.11224 27.5 2.5 21.8878 2.5 15C2.5 8.11224 8.11224 2.5 15 2.5ZM15 4.58333C9.2602 4.58333 4.58333 9.2602 4.58333 15C4.58333 20.7398 9.2602 25.4167 15 25.4167C20.7398 25.4167 25.4167 20.7398 25.4167 15C25.4167 9.2602 20.7398 4.58333 15 4.58333ZM16.1783 15.0001L19.7559 11.4226C20.0817 11.0968 20.0817 10.5701 19.7559 10.2443C19.43 9.91844 18.9034 9.91844 18.5775 10.2443L15 13.8218L11.4225 10.2443C11.0967 9.91844 10.57 9.91844 10.2441 10.2443C9.91831 10.5701 9.91831 11.0968 10.2441 11.4226L13.8217 15.0001L10.2441 18.5776C9.91831 18.9034 9.91831 19.4301 10.2441 19.7559C10.4066 19.9184 10.62 20.0001 10.8333 20.0001C11.0467 20.0001 11.26 19.9184 11.4225 19.7559L15 16.1784L18.5775 19.7559C18.74 19.9184 18.9534 20.0001 19.1667 20.0001C19.38 20.0001 19.5934 19.9184 19.7559 19.7559C20.0817 19.4301 20.0817 18.9034 19.7559 18.5776L16.1783 15.0001Z"
        fill="#677383"
      />
    </svg>
  );
}
